import React, { lazy, Suspense } from "react";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const PendingReceiptUploadsContent = lazy(
  () => import("./PendingReceiptUploadsContent"),
);

const PendingReceiptUploads = () => {
  return (
    <Suspense fallback={<DefaultLoader />}>
      <PendingReceiptUploadsContent />
    </Suspense>
  );
};

export default PendingReceiptUploads;
